<template>
    <section>
        <div class="contact">
            <scroll-parallax :speed="0.1">
                <BackgroundImage image="contact" position="center" />
            </scroll-parallax>
            <div class="container">
                <scroll-parallax :speed="0.15">
                    <div class="contact__header">
                        <h2><span>Kontakta</span> oss</h2>
                        <div class="contact__quote">
                            <Quote
                                text="Vi kan detaljhandeln, inte bara teknik så för oss är kunden och butiken alltid i fokus. Vi är seriösa, vill ha kul och gillar att sprida glädje"
                            />
                        </div>
                    </div>
                </scroll-parallax>
            </div>

            <div class="contact__content">
                <Animate>
                    <div class="container">
                        <h3>
                            Skicka ett meddelande <span>så hör vi av oss</span>
                        </h3>
                        <div class="contact__content-contact">
                            <form
                                class="contact__content-contact-form"
                                id="contact-form"
                            >
                                <div
                                    class="contact__content-contact-form--inputs"
                                >
                                    <div
                                        class="contact__content-contact-form--inputs-group"
                                    >
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            v-model="formData.name"
                                            required
                                            @focus="handleInputFocus"
                                            @blur="handleInputBlur"
                                        />
                                        <label for="name" id="name-label"
                                            >Ditt namn *</label
                                        >
                                    </div>
                                    <div
                                        class="contact__content-contact-form--inputs-group"
                                    >
                                        <input
                                            type="text"
                                            id="company"
                                            v-model="formData.company"
                                            name="company"
                                            @focus="handleInputFocus"
                                            @blur="handleInputBlur"
                                        />
                                        <label for="company" id="company-label"
                                            >Företag (frivilligt)</label
                                        >
                                    </div>
                                </div>
                                <div
                                    class="contact__content-contact-form--inputs"
                                >
                                    <div
                                        class="contact__content-contact-form--inputs-group"
                                    >
                                        <input
                                            type="email"
                                            id="email"
                                            v-model="formData.email"
                                            name="email"
                                            required
                                            @focus="handleInputFocus"
                                            @blur="handleInputBlur"
                                        />
                                        <label for="email" id="email-label"
                                            >E-postadress *</label
                                        >
                                    </div>
                                    <div
                                        class="contact__content-contact-form--inputs-group"
                                    >
                                        <input
                                            type="tel"
                                            id="phone"
                                            v-model="formData.phone"
                                            name="phone"
                                            @focus="handleInputFocus"
                                            @blur="handleInputBlur"
                                        />
                                        <label for="phone" id="phone-label"
                                            >Telefonnummer (frivilligt)</label
                                        >
                                    </div>
                                </div>
                                <div
                                    class="contact__content-contact-form--inputs"
                                >
                                    <div
                                        class="contact__content-contact-form--inputs-group form-message"
                                    >
                                        <textarea
                                            id="msg"
                                            name="msg"
                                            :rows="10"
                                            :cols="2"
                                            v-model="formData.message"
                                            @focus="handleInputFocus"
                                            @blur="handleInputBlur"
                                        ></textarea>
                                        <label for="msg" id="msg-label"
                                            >Meddelande *</label
                                        >
                                    </div>
                                </div>
                                <div
                                    class="contact__content-contact-form--asterisk"
                                    id="validation-error"
                                    v-if="isValidationError"
                                >
                                    Fält markerade med * behöver fyllas i innan
                                    du kan skicka meddelandet
                                </div>
                                <div
                                    class="contact__content-contact-form--inputs"
                                >
                                    <div
                                        class="contact__content-contact-form--inputs-group send-button"
                                    >
                                        <button
                                            type="submit"
                                            id="submit-button"
                                            class="contact__content-contact-form--inputs-group-button"
                                            :disabled="isSending"
                                            @click.prevent="handleFormSubmit"
                                        >
                                            {{
                                                isSending
                                                    ? 'Skickar...'
                                                    : 'Skicka meddelande'
                                            }}
                                        </button>
                                    </div>
                                    <div
                                        class="contact__content-contact-form--inputs-group privacy-policy"
                                    >
                                        <router-link to="/privacy-policy">
                                            <div>
                                                <svg
                                                    width="10"
                                                    height="9"
                                                    viewBox="0 0 10 9"
                                                >
                                                    <path
                                                        d="M0 9V0L9.51956 4.5L0 9Z"
                                                        fill="#C42126"
                                                    />
                                                </svg>
                                                <span
                                                    >Läs mer om hur vi hanterar
                                                    dina uppgifter</span
                                                >
                                            </div>
                                        </router-link>
                                    </div>
                                </div>
                            </form>
                            <div class="contact__content-contact-social">
                                <p
                                    class="contact__content-contact-social--heading"
                                >
                                    Du hittar oss också i sociala medier. Följ
                                    oss gärna för uppdateringar
                                </p>
                                <div
                                    class="contact__content-contact-social-button"
                                >
                                    <div style="padding-bottom: 0.5rem">
                                        <Button
                                            variant="facebook"
                                            href="https://www.facebook.com/Retail-Only-465857273847638/"
                                        >
                                            <template v-slot:text>
                                                Besök oss på
                                                <span style="font-weight: 700"
                                                    >Facebook</span
                                                >
                                            </template>
                                            <template v-slot:icon>
                                                <img
                                                    src="../assets/icons/landing-btn-facebook-icon.svg"
                                                />
                                            </template>
                                        </Button>
                                    </div>
                                    <div>
                                        <Button
                                            variant="linkedin"
                                            href="https://www.linkedin.com/company/retail-only-i-sverige-ab/"
                                        >
                                            <template v-slot:text>
                                                Besök oss på
                                                <span style="font-weight: 700"
                                                    >LinkedIn</span
                                                >
                                            </template>
                                            <template v-slot:icon>
                                                <img
                                                    src="../assets/icons/landing-btn-linkedin-icon.svg"
                                                />
                                            </template>
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Animate>

                <div class="contact__our-team">
                    <div class="container">
                        <h3>Det är vi som är <span>Retail Only</span></h3>
                        <div class="contact__our-team-grid">
                            <Animate>
                                <div class="contact__our-team-grid--person">
                                    <img
                                        src="../assets/images/contact-bjornbylund.png"
                                        alt="Image of Björn Bylund"
                                    />
                                    <div
                                        class="contact__our-team-grid--person-details"
                                    >
                                        <strong>Björn Bylund</strong>
                                        <span>Grundare / VD</span>
                                        <span
                                            class="contact__our-team-grid--person--email"
                                            >bjorn.bylund@retailonly.se</span
                                        >
                                    </div>
                                </div>
                            </Animate>

                            <Animate>
                                <div class="contact__our-team-grid--person">
                                    <img
                                        src="../assets/images/contact-fredrikandersson.png"
                                        alt="Image of Fredrik Andersson"
                                    />
                                    <div
                                        class="contact__our-team-grid--person-details"
                                    >
                                        <strong>Fredrik Andersson</strong>
                                        <span>Grundare / Utvecklare</span>
                                        <span
                                            class="contact__our-team-grid--person--email"
                                            >fredrik.andersson@retailonly.se</span
                                        >
                                    </div>
                                </div>
                            </Animate>
                            <Animate>
                                <div class="contact__our-team-grid--person">
                                    <img
                                        src="../assets/images/contact-bjornhaulin.png"
                                        alt="Image of Björn Haulin"
                                    />

                                    <div
                                        class="contact__our-team-grid--person-details"
                                    >
                                        <strong>Björn Haulin</strong>
                                        <span>Grundare / Utvecklare</span>
                                        <span
                                            class="contact__our-team-grid--person--email"
                                            >bjorn.haulin@retailonly.se</span
                                        >
                                    </div>
                                </div>
                            </Animate>
                            <Animate>
                                <div class="contact__our-team-grid--person">
                                    <img
                                        src="../assets/images/contact-linusbylund.png"
                                        alt="Image of Linus Bylund"
                                    />
                                    <div
                                        class="contact__our-team-grid--person-details"
                                    >
                                        <strong>Linus Bylund</strong>
                                        <span>Förvaltningsansvarig</span>
                                        <span
                                            class="contact__our-team-grid--person--email"
                                            >linus.bylund@retailonly.se</span
                                        >
                                    </div>
                                </div>
                            </Animate>
                            <Animate>
                                <div class="contact__our-team-grid--person">
                                    <img
                                        src="../assets/images/contact-alexanderhammarberg.png"
                                        alt="Image of Alexander Hammarberg"
                                    />

                                    <div
                                        class="contact__our-team-grid--person-details"
                                    >
                                        <strong>Alexander Hammarberg</strong>
                                        <span>Utvecklare</span>
                                        <span
                                            class="contact__our-team-grid--person--email"
                                            >alexander.hammarberg@retailonly.se</span
                                        >
                                    </div>
                                </div>
                            </Animate>
                            <Animate>
                                <div class="contact__our-team-grid--person">
                                    <img
                                        src="../assets/images/contact-magnushedvall.png"
                                        alt="Image of Magnus Hedvall"
                                    />

                                    <div
                                        class="contact__our-team-grid--person-details"
                                    >
                                        <strong>Magnus Hedvall</strong>
                                        <span>Utvecklare</span>
                                        <span
                                            class="contact__our-team-grid--person--email"
                                            >magnus.hedvall@retailonly.se</span
                                        >
                                    </div>
                                </div>
                            </Animate>
                            <Animate>
                                <div class="contact__our-team-grid--person">
                                    <img
                                        src="../assets/images/contact-gustavholmquist.png"
                                        alt="Image of Gustav Holmquist"
                                    />

                                    <div
                                        class="contact__our-team-grid--person-details"
                                    >
                                        <strong>Gustav Holmquist</strong>
                                        <span>Utvecklare</span>
                                        <span
                                            class="contact__our-team-grid--person--email"
                                            >gustav.holmquist@retailonly.se</span
                                        >
                                    </div>
                                </div>
                            </Animate>
                            <Animate>
                                <div class="contact__our-team-grid--person">
                                    <img
                                        src="../assets/images/contact-jonathanolsson.png"
                                        alt="Image of Jonathan Olsson"
                                    />

                                    <div
                                        class="contact__our-team-grid--person-details"
                                    >
                                        <strong>Jonathan Olsson</strong>
                                        <span>Utvecklare</span>
                                        <span
                                            class="contact__our-team-grid--person--email"
                                            >jonathan.olsson@retailonly.se</span
                                        >
                                    </div>
                                </div>
                            </Animate>
                            <Animate>
                                <div class="contact__our-team-grid--person">
                                    <img
                                        src="../assets/images/contact-magnusjonsing.png"
                                        alt="Image of Magnus Jonsing"
                                    />

                                    <div
                                        class="contact__our-team-grid--person-details"
                                    >
                                        <strong>Magnus Jonsing</strong>
                                        <span>Utvecklare</span>
                                        <span
                                            class="contact__our-team-grid--person--email"
                                            >magnus.jonsing@retailonly.se</span
                                        >
                                    </div>
                                </div>
                            </Animate>
                            <Animate>
                                <div class="contact__our-team-grid--person">
                                    <img
                                        src="../assets/images/contact-johandalen.png"
                                        alt="Image of Johan Dalén"
                                    />

                                    <div
                                        class="contact__our-team-grid--person-details"
                                    >
                                        <strong>Johan Dalén</strong>
                                        <span>Utvecklare</span>
                                        <span
                                            class="contact__our-team-grid--person--email"
                                            >johan.dalen@retailonly.se</span
                                        >
                                    </div>
                                </div>
                            </Animate>
                            <Animate>
                                <div class="contact__our-team-grid--person">
                                    <img
                                        src="../assets/images/contact-lukasbrolin.png"
                                        alt="Image of Lukas Brolin"
                                    />

                                    <div
                                        class="contact__our-team-grid--person-details"
                                    >
                                        <strong>Lukas Brolin</strong>
                                        <span>Utvecklare</span>
                                        <span
                                            class="contact__our-team-grid--person--email"
                                            >lukas.brolin@retailonly.se</span
                                        >
                                    </div>
                                </div>
                            </Animate>
                            <Animate>
                                <div class="contact__our-team-grid--person">
                                    <img
                                        src="../assets/images/contact-sebastianfredriksson.png"
                                        alt="Image of Sebastian Fredriksson"
                                    />

                                    <div
                                        class="contact__our-team-grid--person-details"
                                    >
                                        <strong>Sebastian Fredriksson</strong>
                                        <span>Utvecklare</span>
                                        <span
                                            class="contact__our-team-grid--person--email"
                                            >sebastian.fredriksson@retailonly.se</span
                                        >
                                    </div>
                                </div>
                            </Animate>
                            <Animate>
                                <div class="contact__our-team-grid--person">
                                    <img
                                        src="../assets/images/contact-ludwigwappling.png"
                                        alt="Image of Ludwig Wäppling"
                                    />

                                    <div
                                        class="contact__our-team-grid--person-details"
                                    >
                                        <strong>Ludwig Wäppling</strong>
                                        <span>Utvecklare</span>
                                        <span
                                            class="contact__our-team-grid--person--email"
                                            >ludwig.wappling@retailonly.se</span
                                        >
                                    </div>
                                </div>
                            </Animate>
                            <Animate>
                                <div class="contact__our-team-grid--person">
                                    <img
                                        src="../assets/images/contact-melvinbornegrim.png"
                                        alt="Image of Melvin Bornegrim"
                                    />

                                    <div
                                        class="contact__our-team-grid--person-details"
                                    >
                                        <strong>Melvin Bornegrim</strong>
                                        <span>Utvecklare</span>
                                        <span
                                            class="contact__our-team-grid--person--email"
                                            >melvin.bornegrim@retailonly.se</span
                                        >
                                    </div>
                                </div>
                            </Animate>

                            <Animate>
                                <div class="contact__our-team-grid--person">
                                    <img
                                        src="../assets/images/contact-noname.png"
                                        alt="Image of noone"
                                    />
                                    <div
                                        class="contact__our-team-grid--person-details"
                                    >
                                        <strong>Vår nästa kollega?</strong>
                                        <span
                                            >Vi letar alltid efter vassa
                                            utvecklare. Skicka gärna en
                                            spontanansökan.</span
                                        >
                                    </div>
                                </div>
                            </Animate>
                        </div>

                        <Animate>
                            <div class="contact__our-team-additional-info">
                                Du kan nå all personal på Retail Only direkt på
                                <strong>fornamn.efternamn@retailonly.se</strong>
                                men det går såklart lika bra att också skicka
                                e-post på adressen
                                <strong>info@retailonly.se</strong>
                            </div>
                        </Animate>
                    </div>
                </div>
            </div>

            <transition name="slide">
                <div id="submitted-message-success" v-if="isSendingSuccess">
                    Tack för ditt meddelande! Vi återkopplar till dig inom kort.
                </div>
            </transition>
            <transition name="slide">
                <div id="submitted-message-error" v-if="isSendingError">
                    Någonting gick fel. Försök igen eller maila direkt till
                    info@retailonly.se om det fortsatt inte fungerar.
                </div>
            </transition>
        </div>
    </section>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import ScrollParallax from 'vue3-parallax/src/components/ScrollParallax.vue'
import axios from 'axios'

import BackgroundImage from '@/components/Common/BackgroundImage.vue'
import Quote from '@/components/Common/Quote.vue'
import Button from '@/components/Common/Button.vue'
import Animate from '@/components/Common/Animate.vue'

interface FormData {
    name: string
    company: string
    email: string
    phone: string
    msg: string
}

export default defineComponent({
    name: 'Services',
    components: {
        ScrollParallax,
        BackgroundImage,
        Quote,
        Button,
        Animate,
    },
    setup() {
        const formData = ref({
            name: '',
            company: '',
            email: '',
            phone: '',
            message: '',
        })

        const isSending = ref(false)
        const isSendingSuccess = ref(false)
        const isSendingError = ref(false)
        const isValidationError = ref(false)

        const handleFormSubmit = async () => {
            if (isSending.value) return

            if (
                formData.value.name === '' ||
                formData.value.email === '' ||
                formData.value.message === ''
            ) {
                isValidationError.value = true
                return
            } else {
                isValidationError.value = false
            }

            const data: FormData = {
                name: formData.value.name,
                company: formData.value.company,
                email: formData.value.email,
                phone: formData.value.phone,
                msg: formData.value.message,
            }

            try {
                const result = await sendEmail(data)
                if (!result) throw 'Error posting email data'
                isSending.value = false

                // Show success message and remove after 3 seconds
                isSendingSuccess.value = true
                setTimeout(() => {
                    isSendingSuccess.value = false
                }, 3000)

                // Clear form input data
                formData.value = {
                    name: '',
                    company: '',
                    email: '',
                    phone: '',
                    message: '',
                }

                // Clear input active classes
                removeInputActiveClasses()
            } catch (error) {
                isSending.value = false

                // Show error message and remove after 5 seconds
                isSendingError.value = true
                setTimeout(() => {
                    isSendingError.value = false
                }, 5000)

                // eslint-disable-next-line
                console.log(error)
            }
        }

        const handleInputFocus = (e: Event) => {
            if (!e.target) return
            const target = e.target as HTMLInputElement
            target.nextElementSibling?.classList.add('input-active')
        }

        const handleInputBlur = (e: Event) => {
            if (!e.target) return
            const target = e.target as HTMLInputElement
            if (target.value === '') {
                target.nextElementSibling?.classList.remove('input-active')
            }
        }

        const removeInputActiveClasses = () => {
            const group = document.querySelectorAll(
                '.contact__content-contact-form--inputs-group'
            )
            group.forEach((el) => {
                el.firstElementChild?.nextElementSibling?.classList.remove(
                    'input-active'
                )
            })
        }

        const sendEmail = async (data: FormData) => {
            isSending.value = true
            const url =
                process.env.NODE_ENV === 'production'
                    ? 'https://node.retailonly.se'
                    : 'http://localhost:5500'

            const email = await axios.post(
                `${url}/sendemail`,
                JSON.stringify(data),
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )

            if (email.status !== 200) {
                throw new Error(email.statusText || 'Error sending email')
            }

            return email
        }

        return {
            handleInputFocus,
            handleInputBlur,
            formData,
            isSending,
            isSendingSuccess,
            isSendingError,
            handleFormSubmit,
            isValidationError,
        }
    },
})
</script>

<style lang="scss" scoped>
@import '../styles/variables';
@import '../styles/mixins';
@import '../styles/config';

.contact {
    position: relative;

    &__header {
        position: relative;
        padding-top: 20vh;
        height: 80vh;
        z-index: 10;

        @include mQ(700px) {
            padding-top: 18vh;
            text-align: center;
        }
    }

    &__quote {
        position: relative;
        z-index: 20;
    }

    &__content {
        width: 100%;
        padding: 10rem 0 0 0;
        position: relative;
        z-index: 5;

        @include mQ(700px) {
            padding: 6rem 0 0 0;
        }

        &-contact {
            display: grid;
            grid-template-columns: 4fr 1fr;
            justify-content: center;
            align-items: center;
            margin-bottom: 6rem;
            position: relative;
            z-index: 30;

            @include mQ(1024px) {
                grid-template-columns: 1fr;
                margin-bottom: 4rem;
            }

            &-form {
                display: flex;
                flex-direction: column;

                @include mQ(1024px) {
                    margin-bottom: 2rem;
                }

                &--inputs {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 1rem;
                    margin-right: 2rem;

                    @include mQ(750px) {
                        grid-template-columns: 1fr;
                        margin-right: 0;
                        gap: 0;
                    }

                    &-group {
                        position: relative;
                        display: flex;
                        flex-direction: column;
                        margin-bottom: 1rem;

                        label {
                            position: absolute;
                            top: 1.2rem;
                            left: 1.1rem;
                            color: lighten($accent-color, 40%);
                            transition: top 300ms ease-in-out;
                        }

                        .input-active {
                            top: 0.3rem;
                            font-size: 0.8rem;
                        }

                        input,
                        textarea {
                            appearance: none;
                            padding: 1.5rem 1rem 1rem 1rem;
                            font-weight: inherit;
                            font-size: inherit;
                            font-family: inherit;
                            color: $font-color-main-grey;
                            border: 2px solid $accent-color-very-light;
                            background-color: lighten(
                                $accent-color-very-light,
                                4%
                            );
                            border-radius: 5px;

                            &:focus {
                                outline: none;
                                border: 2px solid
                                    darken($accent-color-very-light, 10%);
                                background-color: lighten(
                                    $accent-color-very-light,
                                    2%
                                );
                            }
                        }

                        textarea {
                            width: 100%;
                            resize: none;
                        }

                        input:-webkit-autofill,
                        input:-webkit-autofill:hover,
                        input:-webkit-autofill:focus,
                        textarea:-webkit-autofill,
                        textarea:-webkit-autofill:hover,
                        textarea:-webkit-autofill:focus,
                        select:-webkit-autofill {
                            border: 2px solid $accent-color-very-light;
                            -webkit-text-fill-color: $font-color-main-grey;
                            box-shadow: 0 0 0px 1000px;
                            -webkit-box-shadow: 0 0 0px 1000px
                                lighten($accent-color-very-light, 4%) inset;
                            transition: background-color 300s ease-in-out 0s;
                        }

                        &-button {
                            cursor: pointer;
                            display: block;
                            padding: 1rem;
                            font-size: inherit;
                            font-family: inherit;
                            font-weight: 400;
                            color: $font-color-main-light-grey;
                            border: none;
                            background-color: $accent-color;
                            border-radius: 5px;

                            @include mQ(750px) {
                                margin-bottom: 1rem;
                            }

                            &:hover {
                                background-color: lighten($accent-color, 5%);
                            }
                        }
                    }

                    .form-message {
                        grid-column: 1 / span 2;
                    }

                    .privacy-policy {
                        margin-bottom: 0;
                        align-self: center;
                        justify-self: center;

                        a {
                            color: inherit;
                        }

                        div {
                            display: flex;
                            align-items: center;

                            span {
                                margin-left: 0.3rem;
                                margin-top: 0.1rem;
                            }
                        }
                    }

                    .send-button {
                        margin-bottom: 0;
                    }
                }

                .contact__content-contact-form--asterisk,
                #validation-error {
                    margin-bottom: 1rem;
                    font-size: 0.8rem;
                    text-transform: uppercase;
                    color: $font-color-main-med-grey;
                    transition: display 300ms ease-in-out;
                }

                &-toast {
                    position: relative;
                }
            }

            &-social {
                text-align: center;
                align-self: start;

                p {
                    margin-bottom: 2rem;
                }

                & .btn {
                    margin-bottom: 1rem;

                    @include mQ(1024px) {
                        margin: 1rem auto;
                    }
                }

                &-button {
                    width: 275px;

                    @include mQ(1024px) {
                        display: flex;
                        width: 100%;
                        justify-content: center;

                        & div:first-of-type {
                            margin-right: 1rem;
                        }
                    }

                    @include mQ(550px) {
                        width: 100%;
                        flex-direction: column;

                        & div:first-of-type {
                            margin-right: 0;
                        }
                    }
                }
            }
        }
    }

    &__our-team {
        padding: 6rem 0;
        background: linear-gradient(
            to bottom right,
            #fff,
            lighten($accent-color-very-light, 3%)
        );
        text-align: center;

        @include mQ(700px) {
            padding: 4rem 0 4rem 0;
        }

        &-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
            grid-gap: 2rem;
            margin: 0 auto;

            @include mQ(1024px) {
                grid-template-columns: 1fr;
            }

            @include mQ(550px) {
                width: 100%;
            }

            &--person {
                display: flex;
                border-radius: 100px;
                background: #fff;
                padding: 1rem;
                align-items: center;
                box-shadow: 2px 2px 5px 2px rgba(0, 0, 0, 0.05);

                @include mQ(550px) {
                    padding: 0.8rem;
                }

                img {
                    width: 140px;
                    height: 140px;
                    object-fit: cover;
                    border-radius: 50%;

                    @include mQ(550px) {
                        width: 70px;
                        height: 70px;
                    }
                }

                &-details {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    margin-left: 1rem;
                    text-align: left;

                    strong {
                        font-size: 1.1rem;
                    }

                    span {
                        color: $font-color-main-med-grey;

                        @include mQ(550px) {
                            font-size: 0.85rem;
                        }
                    }
                }

                &-last {
                    grid-column: 1 / 3;

                    @include mQ(1024px) {
                        grid-column: 1 / 2;
                    }
                }

                & a {
                    color: $accent-color;
                }
            }
        }

        &-additional-info {
            width: 70%;
            margin: 4rem auto 0;
            color: $font-color-main-med-grey;

            @include mQ(550px) {
                width: 90%;
            }
        }
    }
}

#submitted-message-success,
#submitted-message-error {
    text-align: center;
    padding: 1rem;
    z-index: 999;
    position: fixed;
    bottom: 10px;
    left: 20%;
    right: 20%;
    background: $accent-color;
    border-radius: 5px;
    color: #fff;

    @include mQ(1024px) {
        left: 1rem;
        right: 1rem;
    }
}

.slide-enter-active,
.slide-leave-active {
    transition: transform 0.3s ease;
}

.slide-enter-from,
.slide-leave-to {
    transform: translateY(100%);
}

.slide-enter-to,
.slide-leave-from {
    transform: translateY(0);
}
</style>
